module.exports = __webpack_public_path__ + "images/emoji/sunrise.ef2e9c1947381fee1332.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sunrise.png
// module id = 70x9
// module chunks = 2